var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGolf = function SvgGolf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.21 9.551c.503 0 .912.411.912.918a.915.915 0 0 1-.912.919.915.915 0 0 1-.913-.919c0-.507.409-.918.912-.918M10.993 12c.504 0 .912.411.912.918a.915.915 0 0 1-.912.919.915.915 0 0 1-.912-.919c0-.507.409-.918.912-.918M14.034 11.388c.504 0 .912.41.912.918a.915.915 0 0 1-.912.919.915.915 0 0 1-.912-.919c0-.507.408-.918.912-.918M15.25 8.939a.915.915 0 0 0-.912.918c0 .507.408.918.912.918a.915.915 0 0 0 .912-.918.915.915 0 0 0-.912-.918"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4 9.551C4 5.381 7.358 2 11.5 2S19 5.38 19 9.551c0 4.17-3.358 7.551-7.5 7.551S4 13.722 4 9.551m7.5-5.918c-3.247 0-5.878 2.65-5.878 5.918s2.631 5.918 5.878 5.918c3.246 0 5.878-2.65 5.878-5.918S14.746 3.633 11.5 3.633",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.95 16.885a.81.81 0 0 1 1.117-.256 8.27 8.27 0 0 0 8.866 0 .81.81 0 0 1 1.118.256.82.82 0 0 1-.254 1.126 9.9 9.9 0 0 1-4.486 1.507v1.666c0 .45-.363.816-.811.816a.814.814 0 0 1-.81-.816v-1.666a9.9 9.9 0 0 1-4.487-1.507.82.82 0 0 1-.254-1.126"
  })));
};
export default SvgGolf;